<template>
  <section class="bg-blue-dark" style="height: 120px;" />
</template>

<script>
export default {
  name: 'HeaderSmall'
}
</script>
